const lotus_download = {
  Genome: [
    {
      Genome: "NLU",
      "Genome (FASTA)": "NLU.genome.fa.gz",
      "Annotation (GFF)": "NLU.genome.gff.gz",
      "DNA Sequences (Gene)": "NLU.genome.gene.gz",
      "mRNA Sequences (Transcripts)": "NLU.genome.transcripts.gz",
      "Coding Sequences (CDS)": "NLU.genome.cds.gz",
      "Protein Sequences (PEP)": "NLU.genome.pep.gz",
    },
    {
      Genome: "American_Lotus_2022",
      "Genome (FASTA)": "American_Lotus_2022.genome.fa.gz",
      "Annotation (GFF)": "American_Lotus_2022.genome.gff.gz",
      "DNA Sequences (Gene)": "American_Lotus_2022.genome.gene.gz",
      "mRNA Sequences (Transcripts)": "American_Lotus_2022.genome.transcripts.gz",
      "Coding Sequences (CDS)": "American_Lotus_2022.genome.cds.gz",
      "Protein Sequences (PEP)": "American_Lotus_2022.genome.pep.gz",
    },
    {
      Genome: "NNU",
      "Genome (FASTA)": "NNU.genome.fa.gz",
      "Annotation (GFF)": "NNU.genome.gff.gz",
      "DNA Sequences (Gene)": "NNU.genome.gene.gz",
      "mRNA Sequences (Transcripts)": "NNU.genome.transcripts.gz",
      "Coding Sequences (CDS)": "NNU.genome.cds.gz",
      "Protein Sequences (PEP)": "NNU.genome.pep.gz",
    },
  ],
  Transcriptome: [
    {
      FPKM: "Comparative_Transcriptome_of_Cotyledons_Reveals_the_Molecular_Mechanism_of_Low-Temperature_Preservation.FPKM.xls",
    },
    {
      FPKM: 
      "Comparative_Transcriptome_of_Lotus_Flower_Buds.FPKM.xls",
    },
    {
      FPKM:   "Comparative_Transcriptome_of_Lotus_Seed_Cotyledon_Development.FPKM.xls",
    },
    {
      FPKM: "Transcriptome_of_Cotyledons_from_Fresh_Lotus_Seeds_during_Postharvest_Storage.FPKM.xls",
    },
    {
      FPKM:     "Transcriptome_of_Different_Lotus_Tissues.FPKM.xls",
    },
    {
      FPKM:   "Transcriptome_of_Lotus_Peduncle_Development.FPKM.xls",
    },
    {
      FPKM:    "Transcriptome_of_Lotus_Seedlings_under_Salt_Stress.FPKM.xls",
    },
    {
      FPKM:"Transcriptome_of_Lotus_Seedpods_under_shading_treatment.FPKM.xls",
    },
    {
      FPKM:   "Transcriptome_of_Lotus_Seed_Cotyledon_Development.FPKM.xls",
    },
    {
      FPKM:  "Transcriptome_of_Lotus_Seed_Plumule_Development.FPKM.xls",
    },
    {
      FPKM:    "Transcriptome_of_Lotus_Stamen_Development.FPKM.xls",
    }, {
      FPKM:     "Transcriptome_of_Lotus_under_Submergence_Stress.FPKM.xls",
    }, {
      FPKM:      "Transcriptome_of_Pericarps_from_Fresh_Lotus_Seeds_during_Postharvest_Storage.FPKM.xls"
    },
  ],
  Other: {},
};
const lotus_downloadTwo = {
  Genome: [
    {
      Genome: "NLU",
      "Genome Sequence (FASTA)": "NLU.fa",
      "Annotation Features (GFF)": "NLU.gff",
      "Genomic Coding Sequence (FASTA)": "",
      "Protein (FASTA)": "",
      "Noo-coding RNA (FASTA)": "",
      "Annotation Statistic (xls)": "",
    },
    {
      Genome: "American_Lotus_2022",
      "Genome Sequence (FASTA)": "American_Lotus_2022.fa",
      "Annotation Features (GFF)": "American_Lotus_2022.gff",
      "Genomic Coding Sequence (FASTA)": "",
      "Protein (FASTA)": "",
      "Noo-coding RNA (FASTA)": "",
      "Annotation Statistic (xls)": "",
    },
    {
      Genome: "NNU",
      "Genome Sequence (FASTA)": "NNU.fa",
      "Annotation Features (GFF)": "NNU.gff",
      "Genomic Coding Sequence (FASTA)": "",
      "Protein (FASTA)": "",
      "Noo-coding RNA (FASTA)": "",
      "Annotation Statistic (xls)": "",
    },
    {
      Genome: "Tai_Zi_lotus",
      "Genome Sequence (FASTA)": "Tai_Zi_lotus.fa",
      "Annotation Features (GFF)": "Tai_Zi_lotus.gff",
      "Genomic Coding Sequence (FASTA)": "",
      "Protein (FASTA)": "",
      "Noo-coding RNA (FASTA)": "",
      "Annotation Statistic (xls)": "",
    },
    {
      Genome: "Zi_lotus",
      "Genome Sequence (FASTA)": "Zi_lotus.fa",
      "Annotation Features (GFF)": "Zi_lotus.gff",
      "Genomic Coding Sequence (FASTA)": "",
      "Protein (FASTA)": "",
      "Noo-coding RNA (FASTA)": "",
      "Annotation Statistic (xls)": "",
    },
  ],
  Expression: {},
  Other: {},
};
export default lotus_download;
